import { type ComponentPropsWithoutRef, memo } from 'react';

import { CommandList, useCommandState } from '@air/cmdk';
import { cn } from '@air/utils-tailwind';

export type ComboboxListProps = ComponentPropsWithoutRef<typeof CommandList>;

export const ComboboxList = memo(({ children, className, ...restOfProps }: ComboboxListProps) => {
  const isEmpty = useCommandState((state) => state.filtered.count === 0);

  return (
    <CommandList className={cn('flex grow flex-col', isEmpty ? 'p-0' : 'p-2', className)} {...restOfProps}>
      {children}
    </CommandList>
  );
});

ComboboxList.displayName = 'ComboboxList';
